import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const CheckedIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      width="28"
      height="27"
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M26 13.5C26 6.87258 20.6274 1.5 14 1.5C7.37258 1.5 2 6.87258 2 13.5C2 20.1274 7.37258 25.5 14 25.5C20.6274 25.5 26 20.1274 26 13.5Z"
        stroke={color ?? 'current-color'}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 9L12.6728 17.25L8.75 13.7848"
        stroke={color ?? 'current-color'}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckedIcon;
